<template>
  <div class="shengming">
    <div class="bgimg"></div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.shengming {
  width: 100vw;
  height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  justify-content: center;
}
.bgimg {
  width: 100vw;
  height: 100vh;
  background: url("../../static/images/shengming.jpg") no-repeat;
  /* background-position: center center; */
  background-size: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Shengming.vue